import React from 'react';
import Scroll from 'react-scroll';

import { DEFAULT_SCROLL_CONFIG } from '@constants/scroll';
import Header from 'modules/Header';
import { getLocationHash } from 'utils/js';

import { Footer, HeaderTags } from '../../components';
import { Container } from './styles';

export type PropTypes = {
  children?: React.ReactNode;
  innerPadding?: boolean;
  title?: string;
  header?: boolean;
  footer?: boolean;
  className?: string;
  description?: string | null;
};

const scrollToAnchorLink = (): void => {
  const hash = getLocationHash()?.slice(1);

  if (hash) {
    setTimeout(() => {
      Scroll.scroller.scrollTo(hash, {
        offset: DEFAULT_SCROLL_CONFIG.OFFSET,
      });
    });
  }
};

const MainLayout = ({
  innerPadding = true,
  children = null,
  title,
  header = true,
  footer = true,
  className,
  description,
}: PropTypes): JSX.Element => {
  React.useLayoutEffect(scrollToAnchorLink, []);

  return (
    <>
      <HeaderTags title={title} description={description || ''} />
      {header && <Header />}
      <Container innerPadding={innerPadding} className={className}>
        {children}
      </Container>
      {footer && <Footer />}
    </>
  );
};

export default MainLayout;
